import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './ContactEmailSection.module.css';
import { useTranslation } from 'react-i18next';

const ContactEmailSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://www.housetechuae.net/send_email.php', formData, { // إزالة 'response' هنا
        headers: {
          'Content-Type': 'application/json',
        },
      });
      toast.success(t("contact.form.successSending"));

      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
      });
    } catch (error) {
      console.error('Error sending message:', error.response ? error.response.data : error.message);
      toast.error(t("contact.form.errorSending"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          className={styles.input}
          name="name"
          placeholder={t("contact.form.namePlaceholder")}
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          className={styles.input}
          name="email"
          placeholder={t("contact.form.emailPlaceholder")}
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          className={styles.input}
          name="phone"
          placeholder={t("contact.form.phonePlaceholder")}
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <textarea
          className={styles.textarea}
          name="message"
          placeholder={t("contact.form.messagePlaceholder")}
          value={formData.message}
          onChange={handleChange}
          required
        />
        <button className={styles.button} type="submit" disabled={loading}>
          {loading ? t("contact.form.sending2Button") : t("contact.form.submitButton")}
        </button>
      </form>
      <ToastContainer />
    </>
  );
};

export default ContactEmailSection;
